import clsx from "clsx";
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { APP_COLORS } from "../../constants/styles";
import { CountryLanguagePickerMobile } from "../CountryLanguagePickerMobile";
import { useSelector } from "react-redux";
import { oauthData, selectIsAuthed, selectIsLogin, selectUserInfo } from "../../redux/authSlice";
import { performLogin } from "../../utils/performLogin";
import SubMenuStyle1 from "./SubMenuStyle1";
import SubMenuStyle2 from "./SubMenuStyle2";
import SubMenuStyle3 from "./SubMenuStyle3";
import SubMenuStyle4 from "./SubMenuStyle4";
import SideMenu from "../SideMenu";
import useCustomTranslation from "../../utils/useCustomTranslation";

function MegaMenuMobile({
    subMenuHeader,
    style,
    setMobileMenuOpen,
    sections = [],
    logo,
    colorObj,
}) {
    const { pathname } = useLocation();

    const [initialPathname] = useState(pathname);

    const [activeSubMenuId, setActiveSubMenuId] = useState(null);

    const [subMenuContent, setSubMenuContent] = useState(null);

    const [sideMenuContent, setSideMenuContent] = useState(null);

    const [closeSubMenuItem, setCloseSubMenuItem] = useState(true);

    const [openSideMenu, setopenSideMenu] = useState(false);

    const [showMainHeader, setShowMainHeader] = useState(true);

    const oauthDetails = useSelector(oauthData);

    const isLoginState = useSelector(selectIsLogin);

    const isAuthed = useSelector(selectIsAuthed);

    const userInfo = useSelector(selectUserInfo);

    const { t } = useCustomTranslation();

    useEffect(() => {
        if (setMobileMenuOpen) {
            document.body.classList.add("overflow-x-hidden", "overflow-y-hidden");
        } else {
            document.body.classList.remove("overflow-x-hidden", "overflow-y-hidden");
        }

        return () => {
            document.body.classList.remove("overflow-x-hidden", "overflow-y-hidden");
        };
    }, [setMobileMenuOpen]);

    useEffect(() => {
        if (pathname !== initialPathname) setMobileMenuOpen(false);
    }, [pathname]);

    useEffect(() => {
        const contentIds = subMenuHeader.map((value) => parseInt(value.content_reference));
        const subMenuContentItems = new Map(
            sections.filter((item) => contentIds.includes(item.id)).map((item) => [item.id, item]),
        );
        setSubMenuContent(subMenuContentItems);
    }, [subMenuHeader]);

    useEffect(() => {
        const subMenuContentItems = sections.filter((item) => item.layout_type === "mobile_menu");
        setSideMenuContent(subMenuContentItems);
    }, [sections]);

    const renderSubMenu = (data, text) => {
        if (!data) {
            return null;
        }

        let innerMenu;
        switch (data?.layout_type) {
            case "sub_menu_style1":
                innerMenu = <SubMenuStyle1 data={data} />;
                break;
            case "sub_menu_style2":
                innerMenu = <SubMenuStyle2 data={data} />;
                break;
            case "sub_menu_style3":
                innerMenu = <SubMenuStyle3 data={data} />;
                break;
            case "sub_menu_style4":
                innerMenu = <SubMenuStyle4 data={data} />;
                break;
            default:
                return null;
        }

        return (
            <>
                <div
                    className={`subMenuHeader transition-all duration-300 transform ${
                        closeSubMenuItem
                            ? "translate-x-0 opacity-100"
                            : "translate-x-full opacity-0"
                    }`}
                >
                    <div className="backMain">
                        <span
                            onClick={() => {
                                setCloseSubMenuItem(false);
                                setShowMainHeader(true);
                            }}
                        >
                            <i className="pi pi-chevron-left text-xl"></i>{" "}
                            {t("constantString.menu")}
                        </span>
                    </div>
                    <div className="rightIcon">
                        <i
                            className="pi pi-times text-2xl"
                            onClick={() => {
                                setCloseSubMenuItem(false);
                                setShowMainHeader(true);
                            }}
                        ></i>
                    </div>
                </div>
                <div
                    className={`subMenu transition-all duration-300 transform overflow-auto pt-[64px]
                        ${
                            closeSubMenuItem
                                ? "translate-x-0 opacity-100"
                                : "translate-x-full opacity-0"
                        }`}
                    style={APP_COLORS(data.colors)}
                >
                    <div>{text}</div>
                    <div className="relative bg-white rounded-2xl overflow-visible flex flex-col md:flex-row z-20">
                        {innerMenu}
                        <div className="mobile-padding-bottom" />
                    </div>
                </div>
            </>
        );
    };

    const renderHeader = ({ text, subMenuId }) => {
        const selected = activeSubMenuId == subMenuId;
        return (
            <div
                className={clsx(
                    "flex flex-row justify-between items-center cursor-pointer capitalize text-lg px-5 py-4",
                    selected && "text-accent-4",
                    !selected && "bg-white text-accent-4",
                )}
                onClick={() => {
                    if (activeSubMenuId === subMenuId) {
                        setCloseSubMenuItem((prev) => !prev);
                        setShowMainHeader(false);
                    } else {
                        setActiveSubMenuId(subMenuId);
                        setCloseSubMenuItem(false);
                        setShowMainHeader(false);
                        setTimeout(() => setCloseSubMenuItem(true), 10);
                    }
                }}
            >
                <div>{text}</div>

                <i className="pi pi-angle-right"></i>
            </div>
        );
    };

    return (
        <div
            style={{ ...style }}
            className={
                "block md:hidden fixed top-0 left-0 w-full h-screen bg-white overflow-auto z-[200] overflow-x-hidden overflow-y-auto"
            }
        >
            {showMainHeader && (
                <div className="flex flex-row justify-between p-3 items-center menu-header">
                    <Link to={"/"}>
                        <img className="h-8 ml-[7px] md:ml:0" src={logo} />
                    </Link>
                    <div className="flex gap-4">
                        <i
                            className="pi pi-times cursor-pointer text-2xl mr-[7px] md:mr:0"
                            onClick={() => setMobileMenuOpen(false)}
                        ></i>
                    </div>
                </div>
            )}

            <div
                className={clsx(
                    "flex flex-col justify-start transition-transform ease-linear duration-300 relative z-10 bg-white rtl-subMenu pt-[64px]",
                )}
            >
                {subMenuHeader.map((value) => {
                    return (
                        <div key={value.heading}>
                            {renderHeader({
                                text: value.heading,
                                subMenuId: parseInt(value.content_reference),
                            })}
                            {activeSubMenuId == parseInt(value.content_reference) &&
                                renderSubMenu(
                                    subMenuContent && subMenuContent.get(activeSubMenuId),
                                    value.heading,
                                )}
                        </div>
                    );
                })}
            </div>
            <div className="SignInCont">
                {isAuthed ? (
                    <div className="signInHldr" onClick={() => setopenSideMenu(true)}>
                        <div className="login-icon">
                            <i className="pi pi-user cursor-pointer"></i>
                        </div>
                        <span>{userInfo.name}</span>
                    </div>
                ) : isLoginState ? (
                    <div className="signInHldr" onClick={() => performLogin(oauthDetails)}>
                        <div className="login-icon">
                            <i className="pi pi-user cursor-pointer"></i>
                        </div>
                        <span>Sign In</span>
                    </div>
                ) : null}
                <CountryLanguagePickerMobile displayType={"header"} />

                {openSideMenu && (
                    <SideMenu
                        subMenuContent={sideMenuContent}
                        closeSideMenu={() => setopenSideMenu(false)}
                        openSideMenu={openSideMenu}
                        colorObj={colorObj}
                    />
                )}
            </div>
        </div>
    );
}

export default MegaMenuMobile;
